export default {
    getDomain() {
        return window.api.get('/domain');
    },

    saveDomain(data) {
        window.api.post('/domain/save', data);
    }
}